import Image from "next/image";
import styles from "../member.module.scss";
import type { Member } from "../_data/members";

type AvatarProps = {
  member: Pick<Member, "name" | "photo" | "initial">;
  variant: "card" | "panel";
  priority?: boolean;
};

const SIZES: Record<AvatarProps["variant"], string> = {
  card: "(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 30vw",
  panel: "(max-width: 1024px) 80vw, 40vw",
};

export default function Avatar({ member, variant, priority }: AvatarProps) {
  if (!member.photo) {
    return (
      <div className={styles.placeholder} aria-hidden="true">
        <span className={styles.initial}>{member.initial}</span>
      </div>
    );
  }

  return (
    <Image
      src={member.photo}
      alt={member.name}
      fill
      style={{ objectFit: "cover" }}
      sizes={SIZES[variant]}
      priority={priority}
    />
  );
}
